import titleTestPage from '@/page/debugbridge/titleTestPage.vue'
export default {
  path: '/titleTestPage',
  name: 'titleTestPage',
  meta: {
    requiresAuth: true,
    title: 'titleTestPage'
  },
  component: titleTestPage
}
